import { createContext } from "react";

const BreadcrumbContext = createContext({
    breadcrumbItems: [],
    setBreadcrumbItems: () => {}
});

export default BreadcrumbContext